/* GUAPI SUMMER SALE 2026 - sale layer v4.9 (draft theme) - PRODUCTION.
   v4.9: ensureBundlePos() relocates the bundle directly under the add-to-cart
   block (after inventory notice) for the first seconds after load - fixes
   deferred PDP renders where the form appears late and the bundle fell to the
   bottom (after description). */
(function(){
  var END = new Date('2026-09-08T23:59:59+02:00').getTime();
  var COLLECTION = '/collections/summer-sale';
  var RANK_URL = 'https://guapi-pnl.guapi-ops.workers.dev/salerank';
  var PREVIEW = /[?&]gpsalepreview=1/.test(location.search);
  var HOSTS = '.product__info-wrapper, .product__info, [class*="product-info"], [class*="product__info"], [class*="product-details"], [class*="product__details"], .product__content';

  if (Date.now() < END && (location.pathname === '/' || location.pathname === '')) {
    location.replace(COLLECTION + location.search);
    return;
  }

  function pad(n){return n<10?'0'+n:''+n}
  function left(){
    var ms = END - Date.now();
    if (ms <= 0) return null;
    var d = Math.floor(ms/86400000), h = Math.floor(ms%86400000/3600000), m = Math.floor(ms%3600000/60000), s = Math.floor(ms%60000/1000);
    return (d>0? d+'d ':'') + pad(h)+':'+pad(m)+':'+pad(s);
  }
  function money(v){ return '$' + Math.round(parseFloat(v)); }
  function isMerch(p){ return !/protection|gift ?card|internal ?test|route|insurance/i.test((p.title||'') + ' ' + (p.handle||'')); }
  function visible(el){ return !!(el && el.offsetParent !== null); }
  function isDefaultOnly(av){ return av.length === 1 && /^default title$/i.test(av[0].title || ''); }
  function cat(title){
    if (/denim|pant|jean|short|cargo|trouser/i.test(title)) return 'bottom';
    if (/shirt|flannel|tee|hoodie|jacket|bomber|sweater|top|crochet/i.test(title)) return 'top';
    if (/star\b|sneaker|shoe|void/i.test(title)) return 'shoe';
    return 'other';
  }
  function tierOf(p){
    var t = (p.tags||[]).join(' ');
    if (t.indexOf('sale-75') > -1) return 75;
    if (t.indexOf('sale-50') > -1) return 50;
    if (t.indexOf('sale-25') > -1) return 25;
    return 0;
  }
  function addItems(items, cb){
    if (window.gpCartAdd) return window.gpCartAdd(items, cb);
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items: items})})
      .then(function(r){ if (!r.ok) throw new Error('add failed'); cb(null); })
      .catch(function(e){ cb(e); });
  }

  var RANK = {};
  function loadRank(cb){
    fetch(RANK_URL).then(function(r){return r.json()}).then(function(d){ RANK = (d && d.units) || {}; cb(); }).catch(function(){ RANK = {}; cb(); });
  }
  function rankOf(p){ return RANK[p.handle] || 0; }

  var INCART = {};
  function loadCart(cb){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      (c.items || []).forEach(function(it){ if (it.product_id) INCART[it.product_id] = 1; });
      cb();
    }).catch(function(){ cb(); });
  }

  var SIZEMEM = { top: null, bottom: null, shoe: null, other: null };
  function rememberSize(title, av, variantId){
    for (var i=0;i<av.length;i++){
      if (av[i].id === variantId && !/^default title$/i.test(av[i].title || '')) {
        SIZEMEM[cat(title)] = av[i].title;
        return;
      }
    }
  }
  function preselFor(title, av, preferredId){
    if (preferredId) { for (var j=0;j<av.length;j++) if (av[j].id === preferredId) return preferredId; }
    var mem = SIZEMEM[cat(title)];
    if (mem) { for (var i=0;i<av.length;i++) if (av[i].title === mem) return av[i].id; }
    return av[0].id;
  }

  function injectNav(){
    document.querySelectorAll('a[href*="lil-baby-x-guapi"]').forEach(function(a){
      var li = a.closest('li');
      if (li) li.remove(); else a.remove();
    });
    var qs = location.search || '';
    document.querySelectorAll('.primary-menu-panel > ul, .header__inline-menu > ul').forEach(function(ul){
      if (!ul || ul.querySelector('.gp-nav-sale')) return;
      var li = document.createElement('li');
      li.className = 'gp-nav-sale';
      li.innerHTML = '<a href="'+COLLECTION+qs+'" class="h4 gp-nav-sale-link">SUMMER SALE</a>';
      var kidsA = null;
      ul.querySelectorAll('a').forEach(function(a){
        if (!kidsA && /kids\s*wear|kidswear/i.test((a.textContent||'') + ' ' + (a.getAttribute('href')||''))) kidsA = a;
      });
      var kli = kidsA ? kidsA.closest('li') : null;
      while (kli && kli.parentNode !== ul) kli = kli.parentNode.closest ? kli.parentNode.closest('li') : null;
      if (kli && kli.parentNode === ul) ul.insertBefore(li, kli.nextSibling);
      else ul.appendChild(li);
    });
  }

  function infoHost(){
    var hosts = document.querySelectorAll(HOSTS);
    for (var i=0;i<hosts.length;i++) if (visible(hosts[i])) return hosts[i];
    if (hosts[0]) return hosts[0];
    var t = document.querySelector('.product__title, h1');
    return t ? t.parentNode : document.querySelector('main');
  }
  function buyForm(){
    var forms = document.querySelectorAll('product-form, form[action*="/cart/add"]');
    var best = null;
    for (var i=0;i<forms.length;i++){
      var f = forms[i];
      if (f.closest('cart-drawer') || f.closest('[class*="sticky"]') || f.closest('header')) continue;
      if (visible(f)) { best = f; break; }
      if (!best) best = f;
    }
    return best;
  }
  function selectedMainVariant(){
    var f = buyForm();
    var inp = f ? f.querySelector('input[name="id"], select[name="id"]') : document.querySelector('input[name="id"]');
    return inp && inp.value ? parseInt(inp.value, 10) : 0;
  }
  function bundleAnchor(){
    var bb = document.querySelector('.product__buy-buttons');
    if (!bb) {
      var f = buyForm();
      if (!f) return null;
      bb = f.closest('[class*="buy-buttons"]') || f;
    }
    var anchor = bb;
    var nx = anchor.nextElementSibling;
    if (nx && /inventory/i.test((nx.id||'') + ' ' + (String(nx.className)||''))) anchor = nx;
    return anchor;
  }
  function ensureBundlePos(){
    var el = document.getElementById('gp-sale-bundle');
    if (!el) return;
    var anchor = bundleAnchor();
    if (!anchor || !anchor.parentNode) return;
    if (el.previousElementSibling === anchor && el.parentNode === anchor.parentNode) return;
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    var rail = document.getElementById('gp-sale-upsell');
    if (rail) el.parentNode.insertBefore(rail, el.nextSibling);
  }
  function mountBundle(el){
    try {
      var anchor = bundleAnchor();
      if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(el, anchor.nextSibling); return true; }
    } catch(e){}
    var h = infoHost();
    if (h) { h.appendChild(el); return true; }
    return false;
  }

  function bar(){
    if (document.getElementById('gp-sale-bar')) return;
    var el = document.createElement('div');
    el.id = 'gp-sale-bar';
    el.innerHTML = '<span><b>SUMMER SALE</b> \u00b7 UP TO 75% OFF</span><span class="gp-cd" id="gp-bar-cd"></span><a href="'+COLLECTION+'">SHOP THE SALE</a>';
    document.body.insertBefore(el, document.body.firstChild);
    requestAnimationFrame(function(){
      var h = el.offsetHeight || 0;
      if (!h) return;
      var hdrs = document.querySelectorAll('sticky-header, header, .header-wrapper, .section-header, [class*="header__wrapper"]');
      for (var i=0;i<hdrs.length;i++){
        var hd = hdrs[i];
        if (!visible(hd)) continue;
        var cs = getComputedStyle(hd);
        if (cs.position === 'fixed' || cs.position === 'sticky' || cs.position === 'absolute') {
          var curTop = parseFloat(cs.top);
          hd.style.top = ((isNaN(curTop) ? 0 : curTop) + h) + 'px';
          break;
        }
      }
    });
  }

  function tierFromTags(tags){
    if (PREVIEW) return 75;
    if (tags.indexOf('sale-75') > -1) return 75;
    if (tags.indexOf('sale-50') > -1) return 50;
    if (tags.indexOf('sale-25') > -1) return 25;
    return 0;
  }

  function saleItems(cb){
    fetch(COLLECTION+'/products.json?limit=24').then(function(r){return r.json()}).then(function(d){
      var items = (d.products||[]).filter(isMerch);
      if (!items.length && PREVIEW) {
        fetch('/products.json?limit=16').then(function(r){return r.json()}).then(function(d2){ cb((d2.products||[]).filter(isMerch)); }).catch(function(){cb([])});
      } else cb(items);
    }).catch(function(){cb([])});
  }

  var CH = { used: {}, saved: 0, round: 0, items: [], product: null };
  function blocked(id){ return CH.used[id] || INCART[id]; }

  function itemPricing(it){
    var av = it.variants.filter(function(v){return v.available});
    if (!av.length) return null;
    var v0 = av[0];
    var sale = parseFloat(v0.price);
    var was = v0.compare_at_price ? parseFloat(v0.compare_at_price) : null;
    return { av: av, sale: sale, was: was };
  }
  function scoredPool(wantCat){
    var out = [];
    for (var i=0;i<CH.items.length;i++){
      var it = CH.items[i];
      if (blocked(it.id)) continue;
      if (CH.product && it.id === CH.product.id) continue;
      var pr = itemPricing(it);
      if (!pr) continue;
      var s = rankOf(it) * 100;
      if (wantCat && cat(it.title||'') === wantCat) s += 4;
      var t = tierOf(it);
      s += (t === 75 ? 3 : t === 50 ? 2 : t === 25 ? 1 : 0);
      out.push({ p: it, pr: pr, s: s });
    }
    out.sort(function(a,b){ return b.s - a.s; });
    return out;
  }
  function itemCard(title, img, pr, selId, preselId){
    var priceHtml = (pr.was && pr.was > pr.sale)
      ? '<span class="gp-b-price"><s>'+money(pr.was)+'</s> <b>'+money(pr.sale)+'</b></span>'
      : '<span class="gp-b-price"><b>'+money(pr.sale)+'</b></span>';
    var single = isDefaultOnly(pr.av);
    var opts = pr.av.map(function(v){ return '<option value="'+v.id+'"'+(v.id===preselId?' selected':'')+'>'+v.title+'</option>'; }).join('');
    var sel = '<select class="gp-b-size" id="'+selId+'"'+(single ? ' style="display:none"' : '')+'>'+opts+'</select>';
    return '<div class="gp-b-item"><img src="'+img+'"><span>'+title+'</span>'+priceHtml+sel+'</div>';
  }
  function pruneRail(){
    var rail = document.getElementById('gp-sale-upsell');
    if (!rail) return;
    rail.querySelectorAll('.gp-card').forEach(function(card){
      var hm = (card.getAttribute('href')||'').match(/\/products\/([a-z0-9\-]+)/);
      if (!hm) return;
      for (var i=0;i<CH.items.length;i++){
        if (CH.items[i].handle === hm[1] && blocked(CH.items[i].id)) { card.remove(); break; }
      }
    });
  }
  function renderRound(){
    var box = document.getElementById('gp-sale-bundle');
    if (!box) return;
    var A, B;
    if (CH.round === 0) {
      var mainAv = (CH.product.variants||[]).filter(function(v){return v.available});
      if (!mainAv.length) { box.remove(); return; }
      A = { title: CH.product.title, img: CH.product.featured_image || '',
            pr: { av: mainAv, sale: parseFloat(CH.product.variants[0].price)/100,
                  was: CH.product.variants[0].compare_at_price ? parseFloat(CH.product.variants[0].compare_at_price)/100 : null },
            id: CH.product.id };
      A.presel = preselFor(A.title, mainAv, selectedMainVariant());
      var mc = cat(CH.product.title||'');
      var pool = scoredPool(mc === 'bottom' ? 'top' : (mc === 'top' ? 'bottom' : null));
      if (!pool.length) { box.remove(); return; }
      B = { title: pool[0].p.title, img: (pool[0].p.images && pool[0].p.images[0] && pool[0].p.images[0].src) || '', pr: pool[0].pr, id: pool[0].p.id };
      B.presel = preselFor(B.title, B.pr.av, 0);
    } else {
      var pool2 = scoredPool(null);
      if (pool2.length < 2) {
        box.innerHTML = '<div class="gp-b-locked">LOCKED IN \u2713 \u00b7 You saved '+money(CH.saved)+' today</div><div class="gp-b-note">That\u2019s every deal we\u2019ve got on this one \u2014 check the sale picks below.</div>';
        return;
      }
      A = { title: pool2[0].p.title, img: (pool2[0].p.images && pool2[0].p.images[0] && pool2[0].p.images[0].src) || '', pr: pool2[0].pr, id: pool2[0].p.id };
      B = { title: pool2[1].p.title, img: (pool2[1].p.images && pool2[1].p.images[1] && pool2[1].p.images[0].src) || (pool2[1].p.images && pool2[1].p.images[0] && pool2[1].p.images[0].src) || '', pr: pool2[1].pr, id: pool2[1].p.id };
      A.presel = preselFor(A.title, A.pr.av, 0);
      B.presel = preselFor(B.title, B.pr.av, 0);
    }
    var total = A.pr.sale + B.pr.sale;
    var wasTotal = (A.pr.was || A.pr.sale) + (B.pr.was || B.pr.sale);
    var save = Math.round(wasTotal - total);
    var head;
    if (CH.round === 0) head = '<h3>Bundle the fit</h3>';
    else head = '<div class="gp-b-locked">LOCKED IN \u2713 \u00b7 Saved '+money(CH.saved)+' so far</div><h3>Next deal \u2014 add these two, save another '+money(save)+'</h3>';
    box.innerHTML = head+
      '<div class="gp-b-row">'+itemCard(A.title, A.img, A.pr, 'gp-b-size-a', A.presel)+'<div class="gp-b-plus">+</div>'+itemCard(B.title, B.img, B.pr, 'gp-b-size-b', B.presel)+'</div>'+
      '<button type="button" class="gp-b-btn" id="gp-b-add">ADD BOTH \u00b7 '+money(total)+'</button>'+
      (save > 0 ? '<div class="gp-b-save">You save '+money(save)+' on this fit</div>' : '')+
      '<div class="gp-b-note">Both ship together \u00b7 sale pricing locked at checkout</div>';
    var btn = document.getElementById('gp-b-add');
    btn.addEventListener('click', function(){
      var sa = document.getElementById('gp-b-size-a');
      var sb = document.getElementById('gp-b-size-b');
      var ia = sa ? parseInt(sa.value, 10) : 0;
      var ib = sb ? parseInt(sb.value, 10) : 0;
      if (!ia || !ib) return;
      btn.disabled = true; btn.textContent = 'ADDING\u2026';
      addItems([{id: ia, quantity:1},{id: ib, quantity:1}], function(err){
        if (err) { btn.disabled = false; btn.textContent = 'ADD BOTH \u00b7 '+money(total); return; }
        rememberSize(A.title, A.pr.av, ia);
        rememberSize(B.title, B.pr.av, ib);
        CH.saved += save;
        CH.used[A.id] = 1; CH.used[B.id] = 1;
        INCART[A.id] = 1; INCART[B.id] = 1;
        CH.round++;
        btn.textContent = 'LOCKED IN \u2713';
        pruneRail();
        setTimeout(renderRound, 700);
      });
    });
  }

  function pdp(){
    var m = location.pathname.match(/\/products\/([a-z0-9\-]+)/);
    if (!m) return;
    fetch('/products/'+m[1]+'.js').then(function(r){return r.json()}).then(function(p){
      var tier = tierFromTags(p.tags||[]);
      var host = infoHost();
      if (tier > 0 && host && !document.querySelector('.gp-pdp-sale')) {
        try {
          var box = document.createElement('div');
          box.className = 'gp-pdp-sale';
          box.innerHTML = '<div class="gp-row"><span>Sale ends in <span class="gp-cd" data-gp-cd></span></span></div>' + (tier===75 ? '<div class="gp-final">Final sale \u00b7 last units \u00b7 no restock</div>' : '');
          host.insertBefore(box, host.firstChild ? host.firstChild.nextSibling : null);
        } catch(e){}
      }
      loadCart(function(){
        loadRank(function(){
          saleItems(function(items){
            CH.items = items; CH.product = p;
            var r = null;
            try {
              if (!document.getElementById('gp-sale-bundle')) {
                var bx = document.createElement('div');
                bx.id = 'gp-sale-bundle';
                mountBundle(bx);
                renderRound();
                if (!bx.innerHTML) bx.remove();
              }
            } catch(e){}
            try { r = railEl(p.id, items); } catch(e){}
            try {
              var bref = document.getElementById('gp-sale-bundle');
              if (r) { if (bref && bref.parentNode) bref.parentNode.insertBefore(r, bref.nextSibling); else { var h = infoHost(); if (h) h.appendChild(r); } }
            } catch(e){ var h2 = infoHost(); if (h2 && r) h2.appendChild(r); }
            ensureBundlePos();
          });
        });
      });
    }).catch(function(){});
  }

  function railEl(excludeId, items){
    if (document.getElementById('gp-sale-upsell')) return null;
    items = items.filter(function(p){return p.id!==excludeId && !INCART[p.id]});
    items.sort(function(a,b){ return rankOf(b) - rankOf(a); });
    items = items.slice(0,10);
    if (!items.length) return null;
    var wrap = document.createElement('div');
    wrap.id = 'gp-sale-upsell';
    var cards = items.map(function(p){
      var v = p.variants && p.variants[0] || {};
      var img = (p.images && p.images[0] && p.images[0].src) || '';
      var was = v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price) ? '<s>'+money(v.compare_at_price)+'</s>' : '';
      return '<a class="gp-card" href="/products/'+p.handle+'"><img loading="lazy" src="'+img+'" alt=""><div class="gp-t">'+p.title+'</div><div class="gp-p">'+was+'<b>'+money(v.price||0)+'</b></div></a>';
    }).join('');
    wrap.innerHTML = '<h3>Complete the fit \u2014 sale picks</h3><div class="gp-strip">'+cards+'</div>';
    return wrap;
  }

  function cart(){
    var host = document.querySelector('cart-drawer .drawer__footer, .cart__footer, cart-drawer form, form[action="/cart"]');
    if (!host || host.querySelector('.gp-cart-sale')) return;
    var el = document.createElement('div');
    el.className = 'gp-cart-sale';
    el.innerHTML = 'SUMMER SALE pricing locked for <b data-gp-cd></b> \u2014 order before it ends';
    host.insertBefore(el, host.firstChild);
  }

  var BUNFIX = 0;
  function tick(){
    var t = left();
    if (t === null) { var b = document.getElementById('gp-sale-bar'); if (b) b.remove(); document.querySelectorAll('.gp-pdp-sale,.gp-cart-sale,#gp-sale-bundle,.gp-nav-sale').forEach(function(e){e.remove()}); return; }
    var bc = document.getElementById('gp-bar-cd'); if (bc) bc.textContent = t;
    document.querySelectorAll('[data-gp-cd]').forEach(function(e){ e.textContent = t; });
    if (BUNFIX < 12) { BUNFIX++; ensureBundlePos(); }
  }

  function boot(){
    if (Date.now() >= END) return;
    bar(); pdp(); cart(); injectNav();
    new MutationObserver(function(){ cart(); injectNav(); }).observe(document.body, {childList:true, subtree:true});
    setInterval(tick, 1000); tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
